import {
  GET_LOCATION_SUGGESTIONS,
  SEARCH_FOR_CITY,
} from './constants'

// This uses the google map api `geocode` to list out the cities.
export function getLocationSuggestions (location, setUserCoords = false) {
  return (dispatch, getState, { googleMaps }) => {
    return dispatch({
      type: GET_LOCATION_SUGGESTIONS,
      payload: googleMaps.geocode(location),
      meta: {
        setUserCoords: setUserCoords,
      },
    })
  }
}

// This uses the panama api `/search_for_city/` to list out the cities.
export function searchForCity (city) {
  return (dispatch, getState, { mapmy }) => {
    return dispatch({
      type: SEARCH_FOR_CITY,
      payload: mapmy.searchForCity(city),
    })
  }
}
